import { Component, OnInit, ViewEncapsulation, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Card } from './../model/card';
import { CardsEventType } from './../cards.event.type';
import { EventTypes } from '../../../shared/EventTypes';
import { CardsService } from '../cards.service';

@Component({
	selector: 'app-list-cards',
	templateUrl: './list-cards.component.html',
	styleUrls: ['./list-cards.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ListCardsComponent implements OnInit, OnDestroy {

	@Input() submited = false;
	@Input() cardData: Card;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() setTitle: EventEmitter<any> = new EventEmitter<any>();


	public form: FormGroup;
	private view = '[data-component="list-cards"]';
	public active: boolean = false;
	public cardAtivoNum: string;

	private cardsList: Array<Card>;

	slideConfig = {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		infinite: false,
		prevArrow: '<button type="button" class="slick-prev material-icons arrow"><span>&#xE5C5;</span></button>',
		nextArrow: '<button type="button" class="slick-next material-icons arrow"><span>&#xE5C5;</span></button>',
		draggable: false
	};


	constructor(private cardsService: CardsService) { }

	ngOnInit() {
		AppEventDispatcher.listen(CardsEventType.STEPS.LIST_CARDS, data => {
			if (data.show) {
				this.setForm.emit(this.form);
				this.setTitle.emit({
					title: 'Meus Cartões',
				});
				this.show();
			} else {
				this.hide();
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(CardsEventType.STEPS.LIST_CARDS);
	}

	show() {
		this.preload(true);
		this.cardsService.getCards(this.cardData.num).subscribe(data => {
			this.active = true;

			this.cardsList = data;

			TweenMax.delayedCall(.6, () => {
				this.preload(false);

				const containerHeight = $('[data-component="list-cards"]').outerHeight() + 30;

				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });

				AppEventDispatcher.dispatch(CardsEventType.ACTIONS.BUTTONS, { show: false });

			});
		}, error => {
			TweenMax.delayedCall(.4, () => {
				this.preload(false);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				AppEventDispatcher.dispatch(CardsEventType.STEPS.DATA_CARDS, { show: true });
				AppEventDispatcher.dispatch(CardsEventType.ACTIONS.BUTTONS, { show: true });
			});

		});
	}

	hide() {
		this.active = false;
	}

	unlockOrBlockCard(num, state) {
		this.hide();
		this.cardData.state = state;
		this.cardData.num = num;

		TweenMax.delayedCall(.2, () => {
			AppEventDispatcher.dispatch(CardsEventType.STEPS.CONFIRM_CARDS, { show: true });
		});

		AppEventDispatcher.dispatch(CardsEventType.ACTIONS.BUTTONS, { show: true });
	}

	changePass(num) {
		this.hide();
		this.cardData.num = num;
		TweenMax.delayedCall(.2, () => {
			AppEventDispatcher.dispatch(CardsEventType.STEPS.CHANGE_PASS, { show: true });
			AppEventDispatcher.dispatch(CardsEventType.ACTIONS.BUTTONS, { show: true });
		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="cards"] .content', show: active, delay: delay });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/cards/list-cards/list-cards.component.ts